import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'containers/services/translate';
import SahamDialog from 'components/SahamDialog';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RiskAmount/messages';
import { numberWithCommas } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import { get, isEmpty } from 'lodash';
import { Grid, TextField } from '@material-ui/core';
import { RcCorporeal } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { REGULATION_AMOUNTS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';

export interface DialogFeesProps {
  intl: IntlShape;
  open: boolean;
  handleClose: Function;
  handleValidate: any;
  item: any;
  handleChange: Function;
  rcCorporeal: RcCorporeal;
  title: any;
  feeType: string;
  disabled: boolean;
  isBasicManagementRegulation?: boolean;
}

const DialogFees: React.FC<DialogFeesProps> = (props): JSX.Element => {
  const isDisabled = React.useMemo(() => {
    return (
      props.isBasicManagementRegulation &&
      isEmpty(get(props?.item?.regulationAmount, props.feeType, ''))
    );
  }, [
    props.isBasicManagementRegulation,
    props?.item?.regulationAmount,
    props.feeType,
  ]);
  return (
    <SahamDialog
      handleValidate={props.handleValidate}
      handleClose={props.handleClose as any}
      title={props.title}
      cancelTitle={translate(messages.cancelButton, props)}
      confirmTitle={translate(messages.confirmationButton, props)}
      open={props.open}
      validateButtonDisabled={props.disabled}
    >
      <div>
        <Grid container direction="column">
          <TextField
            fullWidth
            label={
              props.feeType === REGULATION_AMOUNTS.FUNERAL_FEES
                ? translate(messages.deceasedFuneralFees, props)
                : translate(messages.deceasedMedicalFees, props)
            }
            name={props.feeType}
            id={props.feeType}
            value={numberWithCommas(
              String(get(props?.item?.regulationAmount, props.feeType, '')),
            )}
            style={{ marginBottom: '10px' }}
            onChange={props.handleChange(props.rcCorporeal, props.item)}
          />
          <Grid item spacing={2}>
            <TextField
              fullWidth
              label={translate(messages.reason, props)}
              value={get(
                props.item,
                `regulationAmount.${props.feeType}Reason`,
                '',
              )}
              name={`${props.feeType}Reason`}
              onChange={props.handleChange(props.rcCorporeal, props.item)}
              disabled={isDisabled}
            />
          </Grid>
        </Grid>
      </div>
    </SahamDialog>
  );
};

export default injectIntl(DialogFees);
